import { SET_MODE } from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default (mode) => createProposalModalActions[SET_MODE](mode);
